import { Stack } from '@mui/material'
import PageSection from '../../../Constants&Theme/PageSection'
import { useGetContainerLineInstructions } from '../../../APIs/Hooks/ContainerHooks'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { stackGap } from '../../../Constants&Theme/Spacing'

function LineInstructions() {
  const lineQuery = useGetContainerLineInstructions()
  return (
    <PageSection
      title={'Line Instructions'}
      loading={lineQuery.isLoading}
    >
      <Stack
        direction={'row'}
        width={1}
        gap={stackGap.row}
      >
        <DataGridPro
          autoHeight
          disableColumnMenu
          hideFooter
          density={'compact'}
          rows={lineQuery.data ?? []}
          getRowId={(row) => row.LineID}
          columns={[
            {
              field: 'GenotypeService',
              headerName: 'Genotype Service',
              flex: 1,
            },
            {
              field: 'TissueCollectionComments',
              headerName: 'Tissue Comments',
              flex: 2,
            },
            {
              field: 'IdentificationComments',
              headerName: 'Identification Comments',
              flex: 2,
            },
          ]}
        />
      </Stack>
    </PageSection>
  )
}

export default LineInstructions
